<a
[href]="lang + 'profile/'+id?.toString()+'/biography'"
class="athlete"
[ngStyle]="color != null ? {'color':color} : {}"
data-th="name"
>
<!--[routerLink]="['/athlete/',id?.toString()]"-->
<div
[ngStyle]="color != null ? {'color':color} : {}"
  [ngClass]="(wnameord == true ) ? 'athlete__lastname' : 'athlete__name'"
>
  {{
    (wnameord == true)
      ? fname
      : gname
  }}
</div>
<div
[ngStyle]="color != null ? {'color':color} : {}"
  [ngClass]=" (wnameord == false) ? 'athlete__lastname' : 'athlete__name'"
>
  {{

    (wnameord == false)
      ? fname
      : gname
  }}
</div>
</a>
